import { all } from 'redux-saga/effects';
import deleteSaga from 'sagas/entity/delete';

export default function* checkup() {
  yield all([deleteSaga()]);
}
